import React, { Component } from 'react';

import Conteudo from './Conteudo';
import FormularioAcesso from './modules/auth/FormularioAcesso';

export default class extends Component {
  render() {
    return (
      <div>
        <Conteudo>
          404 - A página solicitada não foi encontrada.
          <br /><br />
          Solicite acesso preenchendo os campos abaixo:
          <FormularioAcesso />
        </Conteudo>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NotFound.js